<template>
  <div class="w-full">
    <Panel header="Quản lý nhóm">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <section class="md:col-span-12">
          <div class="rounded-lg border border-slate-200 bg-white p-4">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Tên nhóm</label>
                <InputText
                  id="groupname"
                  type="text"
                  v-model="groupCreate.groupName"
                  placeholder="Nhập tên nhóm"
                />
              </div>
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Thêm nhóm</label>
                <Button
                  label="Thêm"
                  icon="pi pi-plus-circle"
                  iconPos="left"
                  @click="addGroup()"
                  :loading="addingGroup"
                  :disabled="!groupCreate.groupName"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="md:col-span-12">
          <div class="rounded-lg border border-slate-200 bg-white">
            <div
              class="border-b border-slate-200 bg-slate-50 px-4 py-3 text-[15px] font-bold text-slate-900"
            >
              Thêm thành viên vào nhóm
            </div>
            <div class="grid grid-cols-1 gap-4 p-4 md:grid-cols-12">
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Chọn nhóm</label>
                <Dropdown
                  id="groupselect"
                  v-model="idGroup"
                  :options="listGroup"
                  optionLabel="groupName"
                  optionValue="id"
                  :filter="true"
                >
                </Dropdown>
              </div>
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Chọn thành viên</label>
                <Dropdown
                  id="memberselect"
                  v-model="idCustomer"
                  :options="listCustomer"
                  optionLabel="name"
                  optionValue="idMember"
                  :filter="true"
                >
                  <template #option="slotProps">
                    <div class="flex items-center gap-2">
                      <img
                        v-if="slotProps.option.imageUrl"
                        :src="slotProps.option.imageUrl"
                        class="mr-1 h-5 w-5 rounded object-cover"
                      />
                      <label class="m-0 font-medium text-slate-800">{{
                        slotProps.option.name
                      }}</label>
                    </div>
                  </template>
                </Dropdown>
              </div>
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Thêm thành viên vào nhóm</label>
                <Button
                  label="Thêm"
                  icon="pi pi-plus-circle"
                  iconPos="left"
                  @click="addMember()"
                  :loading="addingMember"
                  :disabled="!(idGroup && idCustomer)"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="md:col-span-12">
          <div class="rounded-lg border border-slate-200 bg-white">
            <div
              class="border-b border-slate-200 bg-slate-50 px-4 py-3 text-[15px] font-bold text-slate-900"
            >
              Xóa thành viên ra khỏi nhóm
            </div>
            <div class="grid grid-cols-1 gap-4 p-4 md:grid-cols-12">
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Chọn nhóm</label>
                <Dropdown
                  id="groupselectdelete"
                  v-model="idGroupDelete"
                  :options="listGroup"
                  optionLabel="groupName"
                  optionValue="id"
                  @change="selectGroup"
                  :filter="true"
                >
                </Dropdown>
              </div>
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Chọn thành viên</label>
                <Dropdown
                  id="memberselectdelete"
                  v-model="idMemberDelete"
                  :options="memberInGroup"
                  optionLabel="zaloName"
                  optionValue="id"
                  :filter="true"
                >
                </Dropdown>
              </div>
              <div class="flex min-w-0 flex-col md:col-span-4">
                <label>Xóa thành viên ra khỏi nhóm</label>
                <Button
                  label="Xóa"
                  icon="pi pi-trash"
                  iconPos="left"
                  @click="deleteMember()"
                  severity="danger"
                  :loading="deletingMember"
                  :disabled="!(idGroupDelete && idMemberDelete)"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </Panel>
  </div>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import AuthRepository from "@/services/AuthRepository";
import { useToast } from "@/ui/services/toast";
import { useRouter } from "vue-router";
import { Register } from "../models/register";
import { useStore } from "vuex";
import TeamRepository from "../services/TeamRepository";
import { Team } from "@/models/team.models";
import { ListCustomer } from "@/models/listCustomer";
import ZaloRepository from "@/services/ZaloRepository";
import { EmployeeCreate } from "@/models/employeeCreate";
import zaloRepository from "@/services/ZaloRepository";
import { GroupCreate } from "@/models/groupCreate";
import teamRepository from "../services/TeamRepository";
import { Group } from "@/models/group";
import { MemberInGroupCreate } from "@/models/memberInGroupCreate";
import { MemberInGroup } from "@/models/memberInGroup";

export default {
  setup() {
    const router = useRouter();
    const register = ref({} as Register);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const groupCreate = ref({} as GroupCreate);
    const listGroup = ref([] as Group[]);
    const listCustomer = ref([] as ListCustomer[]);
    const idGroup = ref(0);
    const idCustomer = ref(0);
    const idGroupDelete = ref(0);
    const idMemberDelete = ref(0);
    const memberInGroup = ref([] as MemberInGroup[]);
    const addingGroup = ref(false);
    const addingMember = ref(false);
    const deletingMember = ref(false);

    const loadListGroup = () => {
      zaloRepository
        .listGroup()
        .then((response) => {
          listGroup.value = response.data;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        });
    };
    loadListGroup();

    const loadListMember = () => {
      zaloRepository
        .getListCustomer()
        .then((response) => {
          listCustomer.value = response.data;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
        });
    };

    loadListMember();

    const addGroup = () => {
      addingGroup.value = true;
      zaloRepository
        .createNewGroup(groupCreate.value)
        .then((response) => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Thêm nhóm mới thành công",
            life: 2000,
          });
          loadListGroup();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        })
        .finally(() => {
          addingGroup.value = false;
        });
    };

    const addMember = () => {
      addingMember.value = true;
      zaloRepository
        .addMemberToGroup(idCustomer.value, idGroup.value)
        .then((response) => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Thêm thành viên vào nhóm thành công",
            life: 2000,
          });
          loadListGroup();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        })
        .finally(() => {
          addingMember.value = false;
        });
    };

    const selectGroup = () => {
      console.log(
        "################### selectGroup idGroupDelete: " + idGroupDelete.value,
      );
      if (idGroupDelete.value > 0)
        zaloRepository
          .getListMemberInGroup(idGroupDelete.value)
          .then((response) => {
            memberInGroup.value = response.data;
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
    };

    const deleteMember = () => {
      deletingMember.value = true;
      zaloRepository
        .deleteMember(idMemberDelete.value)
        .then((response) => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xóa thành viên ra khỏi nhóm thành công",
            life: 2000,
          });
          selectGroup();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        })
        .finally(() => {
          deletingMember.value = false;
        });
    };

    return {
      register,
      error,
      addGroup,
      groupCreate,
      listCustomer,
      listGroup,
      idGroup,
      idCustomer,
      addMember,
      idGroupDelete,
      idMemberDelete,
      selectGroup,
      memberInGroup,
      deleteMember,
      addingGroup,
      addingMember,
      deletingMember,
    };
  },
};
</script>
